
export class BusinessUnit {

    name: string;

    constructor(name: string) {
        this.name = name;
    }
}